var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchAndReplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1491 13.7358C25.345 13.7358 12.518 26.5475 12.518 42.3669H8.54688C8.54688 24.3529 23.1532 9.76465 41.1491 9.76465H61.1991V13.7358H41.1491Z",
    fill: "#16104F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3005 12.9L60.3672 5V20.8L68.3005 12.9Z",
    fill: "#16104F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6837 66.1477C53.4878 66.1477 66.3148 53.336 66.3148 37.5166H70.286C70.286 55.5306 55.6796 70.1189 37.6837 70.1189H17.6504V66.1477H37.6837Z",
    fill: "#16104F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5332 66.983L18.4665 74.883V59.083L10.5332 66.983Z",
    fill: "#170F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4991 57.3497H29.2324V23.083H50.6324V57.3497H46.3658",
    fill: "#00BAC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.248 21.0977H52.6192V59.3355H46.367V55.3643H48.648V25.0688H31.2192V55.3643H33.5003V59.3355H27.248V21.0977Z",
    fill: "#16104F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2506 55.9184H37.834V51.9473H42.2506V55.9184Z",
    fill: "#16104F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAndReplace);
export default __webpack_public_path__ + "static/media/switch-and-replace.88668bbb35164e9ee270abf306d4eef1.svg";
export { ForwardRef as ReactComponent };